import { FILTERS_COMPONENT_SOWING_DATE } from '@features/regional-overview/domain/tests-id.constants';
import {
  RegionalOverviewFilterType,
  type FilterValue,
  type RegionalOverviewFilterType as FilterTypeAlias
} from '@features/regional-overview/regional-overview.models';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import RangePickerFilterComponent from '../../components/range-picker-filter/range-picker-filter.component';
import { useFiltersStore } from '../../filters.store';

interface SowingDateSectionProps {
  defaultExpanded?: boolean;
}

const SowingDateSection = ({ defaultExpanded }: SowingDateSectionProps) => {
  const [t] = useTranslation();
  const selectedValue = useFiltersStore(state => state.values[RegionalOverviewFilterType.SOWING_DATE]);
  const setValue = useFiltersStore(state => state.setValue);

  const handleFilterChanged = useCallback(
    (_filter: FilterTypeAlias, value: FilterValue) => {
      setValue(RegionalOverviewFilterType.SOWING_DATE, value);
    },
    [setValue]
  );

  return (
    <RangePickerFilterComponent
      filter={RegionalOverviewFilterType.SOWING_DATE}
      selectedValue={selectedValue}
      onFilterChanged={handleFilterChanged}
      title={t('pages.regional_overview.regional_risk.planting')}
      defaultExpanded={defaultExpanded}
      dataTestID={FILTERS_COMPONENT_SOWING_DATE}
    />
  );
};

export default SowingDateSection;
